import styled, { css } from 'styled-components';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_SIZE } from './Table.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const TableRoot = styled.table `
  border-collapse: collapse;
  width: auto;

  /* Sizing
  --------------------------------------------------------*/
  &,
  td,
  th {
    ${({ size }) => css `
      padding: ${MAPPINGS_SIZE[size].padding};
      font-size: ${MAPPINGS_SIZE[size].fontSize};
    `}
  }

  th {
    font-weight: ${tokens.font.weight.bold.value};
    text-transform: uppercase;
  }

  /* WIDTH
  --------------------------------------------------------*/
  ${({ width }) => width === 'full' &&
    css `
      width: 100%;
    `}

  /* ZEBRA
  --------------------------------------------------------*/
  ${({ zebra }) => !!zebra &&
    css `
      tbody tr:nth-child(odd) {
        background-color: ${tokens.colors.midnight[100].value};
      }
    `}

  /* BORDER
  --------------------------------------------------------*/
  &,
  td,
  th {
    border: 1px solid ${tokens.colors.midnight[200].value};
  }

  ${({ borderType }) => borderType === 'separator' &&
    css `
      & {
        border: 1px solid ${tokens.colors.midnight[200].value};

        td,
        th {
          border: 0;
        }
      }

      tr {
        border-bottom: 1px solid ${tokens.colors.midnight[200].value};
      }
    `}

  ${({ borderType }) => borderType === 'none' &&
    css `
      &,
      td,
      th {
        border: 0;
      }
    `}
`;
export const TableWrapper = styled.div ``;
//# sourceMappingURL=Table.styled.js.map